export const initMenu = ({
  openButtonId,
  closeButtonId,
  listId,
  openedStateClass,
  sectionLinksId,
}) => {
  const menuBtn = document.getElementById(openButtonId);
  const menuBtnClose = document.getElementById(closeButtonId);
  const menuList = document.getElementById(listId);

  if (menuBtn) {
    menuBtn.addEventListener('click', () => {
      if (menuList.classList.contains(openedStateClass)) {
        menuList.classList.remove(openedStateClass);
      } else {
        menuList.classList.add(openedStateClass);
      }
    });

    menuBtnClose.addEventListener('click', () => {
      menuList.classList.remove(openedStateClass);
    });

    const linksListElement = document.getElementById(sectionLinksId);

    if (linksListElement) {
      linksListElement.addEventListener('click', (e) => {
        if (e.target.tagName.toUpperCase() === 'A') {
          menuList.classList.remove(openedStateClass);
        }
      });
    }
  }
};
